// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".survey-title[data-v-18d4c9ce] {\n  font-size: 2rem;\n  font-weight: bold;\n  line-height: 1.3;\n  text-align: center;\n  padding-top: 2rem;\n  color: #424982;\n}\n.skip-link[data-v-18d4c9ce] {\n  padding: 1rem 4rem;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 500;\n  color: #7d8bf7;\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n}", ""]);
// Exports
module.exports = exports;
